var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/electrical_demand.template.html');

var TheView = GenericView.extend({
    el: '#electrical_demand',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	frontEndData: null,
	initialize: function (options) {
	    this.data = options.data;
	    this.frontEndData = options.frontEndData;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template(this.data));
        this.createElectricalChart();
    },
    events: {
        "click #exportElectrical" : "exportData",
        "click #exportPDevDay" : "exportPDevDay",
        "click #exportPDevMin" : "exportPDevMin",
        "click #exportPDevSim" : "exportPDevSim"
    },
    createElectricalChart: function() {
        var ctx = document.getElementById('electricalChart').getContext('2d');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
                datasets: [
                    {
                        label: "Electrical Load",
                        backgroundColor: "#010164",
                        data: this.data.electricalDemand
                    }
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                title: {
                    display: false,
                    text: 'Electrical Demand',
                    fontSize: '20'
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Months'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Electrical Demand (kWh)'
                        },
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });

        myChart.canvas.parentNode.style.height = '400px';
        myChart.canvas.parentNode.style.width = '90%';
    },
    exportData: function() {
         var self = this;

         $.ajax({
             url: "/api/export2/electricalDemand",
             type: "POST",
             contentType: "application/json",
             data: JSON.stringify(self.frontEndData),
             dataType : 'binary',
             xhrFields : {
                'responseType' : 'blob'
             }
         }).done(function(response) {
            var url = URL.createObjectURL(response);
            var $a = $('<a />', {
              'href': url,
              'download': 'ElectricalDemand.csv',
              'text': "click"
            }).hide().appendTo("body")[0].click()

         }).fail(function(resp, xhr, errorMessage) {
             console.error("resp: ", resp);
             console.error("xhr: ", xhr);
             console.error("status: ", errorMessage);
         });

    },
    exportPDevDay: function() {
         var self = this;

         $.ajax({
             url: "/api/export2/p_dev_day",
             type: "POST",
             contentType: "application/json",
             data: JSON.stringify(self.frontEndData),
             dataType : 'binary',
             xhrFields : {
                'responseType' : 'blob'
             }
         }).done(function(response) {
            var url = URL.createObjectURL(response);
            var $a = $('<a />', {
              'href': url,
              'download': 'p_dev_day.csv',
              'text': "click"
            }).hide().appendTo("body")[0].click()

         }).fail(function(resp, xhr, errorMessage) {
             console.error("resp: ", resp);
             console.error("xhr: ", xhr);
             console.error("status: ", errorMessage);
         });

    },
    exportPDevMin: function() {
         var self = this;

         $.ajax({
             url: "/api/export2/p_dev_min",
             type: "POST",
             contentType: "application/json",
             data: JSON.stringify(self.frontEndData),
             dataType : 'binary',
             xhrFields : {
                'responseType' : 'blob'
             }
         }).done(function(response) {
            var url = URL.createObjectURL(response);
            var $a = $('<a />', {
              'href': url,
              'download': 'p_dev_min.csv',
              'text': "click"
            }).hide().appendTo("body")[0].click()

         }).fail(function(resp, xhr, errorMessage) {
             console.error("resp: ", resp);
             console.error("xhr: ", xhr);
             console.error("status: ", errorMessage);
         });

    },
    exportPDevSim: function() {
         var self = this;

         $.ajax({
             url: "/api/export2/p_dev_sim",
             type: "POST",
             contentType: "application/json",
             data: JSON.stringify(self.frontEndData),
             dataType : 'binary',
             xhrFields : {
                'responseType' : 'blob'
             }
         }).done(function(response) {
            var url = URL.createObjectURL(response);
            var $a = $('<a />', {
              'href': url,
              'download': 'p_dev_sim.csv',
              'text': "click"
            }).hide().appendTo("body")[0].click()

         }).fail(function(resp, xhr, errorMessage) {
             console.error("resp: ", resp);
             console.error("xhr: ", xhr);
             console.error("status: ", errorMessage);
         });

    }
});

module.exports= TheView;